import React, { Component } from 'react'
import { API_BASE, getImageUrl } from 'config/api';
class ListProject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            caseStudies: [],
            loading: true
        }
    }

    async componentDidMount() {
        try {
            const res = await fetch(`${API_BASE}/case-studies?limit=4`);
            const data = await res.json();
            const items = Array.isArray(data.caseStudies) ? data.caseStudies : (Array.isArray(data) ? data : []);
            this.setState({ caseStudies: items, loading: false });
        } catch (e) {
            this.setState({ caseStudies: [], loading: false });
        }
    }
    
    render() {
        const { caseStudies, loading } = this.state;

        if (loading) {
            return (
                <div className="row">
                    <div className="col-md-12" style={{ textAlign: 'center', padding: '40px 0', color: '#718096' }}>
                        Loading case studies...
                    </div>
                </div>
            );
        }

        if (!caseStudies.length) {
            return (
                <div className="row">
                    <div className="col-md-12" style={{ textAlign: 'center', padding: '40px 0', color: '#718096' }}>
                        Case studies coming soon.
                    </div>
                </div>
            );
        }

        return (
            <div className="row case-studies-row modern-home-card-grid">
                {
                    caseStudies.map(cs => (
                        <div className="col-lg-3 col-md-6 col-sm-12" key={cs.id}>
                            <article className="modern-tile-card modern-case-tile">
                                <div className="modern-tile-media">
                                    <img
                                        src={getImageUrl(cs.image) || (process.env.PUBLIC_URL || '') + '/images/logo@2x.png'}
                                        alt={cs.title}
                                        onError={(e) => { e.target.src = (process.env.PUBLIC_URL || '') + '/images/logo@2x.png'; }}
                                    />
                                </div>
                                <div className="modern-tile-overlay">
                                    <span>{cs.industry || cs.category || 'Case Study'}</span>
                                    <h3>{cs.title}</h3>
                                    <p>{cs.results || cs.challenge || 'Research, analytics, and evaluation support with practical recommendations.'}</p>
                                    <i className="fa fa-line-chart" aria-hidden="true" />
                                </div>
                            </article>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ListProject;
